module.exports = __webpack_public_path__ + "static/img/role.2784f6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/feature/role.png
// module id = gEM8
// module chunks = 7